import React, {useEffect, useState} from 'react'
import {useHistory, useLocation} from "react-router-dom"
import emitter from "@/util/ev"
import '@/assets/css/head.scss'
import wxImg from '@/assets/img/icon/wx.png'
import wbImg from '@/assets/img/icon/wb.png'
import telImg from '@/assets/img/icon/tel.png'
import {queryString, scrollToTop, setQueryString} from "@/util";

const Footer = (props) => {
    const [langList] = useState([
        {
            lang: 'Cn',
            type: 1
        },
        {
            lang: 'En',
            type: 2,
        }
    ])
    const [langIndex, setLangIndex] = useState(0)
    const history = useHistory();
    const location = useLocation()

    useEffect(() => {
        initData()
    }, [])

    const changeLang = (item, index) => {
        const lang = item.type === 1 ? 'zh-CN' : 'en-US'
        const query =  queryString()
        query.lang = lang
        const path = location.pathname + setQueryString(query)
        history.replace(path)
        window.location.reload()
        scrollToTop()
    }
    const initData = () => {
        let index = 0
        const lang = queryString('lang')
        if (lang) {
            if (lang === 'en-US') {
                index = 1
            }
        }
        setLangIndex(index)
        return index
    }
    const changeImg = (type) => {
        emitter.emit("callMe", type);
    }

    return (
        <footer className="footer flex-between">
            <div className="footer-left flex-between">
                <div className="footer-share flex-between">
                    <div className="share-item" onClick={() => changeImg('wx')}>
                        <img src={wxImg} alt=""/>
                    </div>
                    <div className="share-item" onClick={() => changeImg('wb')}>
                        <img src={wbImg} alt=""/>
                    </div>
                    <div className="share-item" onClick={() => changeImg('tel')}>
                        <img src={telImg} alt=""/>
                    </div>
                </div>
                <div className="icp">
                    沪ICP备16002886号-2
                </div>
            </div>
            <div className="footer-right flex-center">
                <div className="lang-list flex-between">
                    {
                        langList.map((val, index) => {
                            return (
                                <div className={`lang-item ${ langIndex === index ? 'active' : ''}`}
                                     key={index}
                                     onClick={() => changeLang(val, index)}
                                >{val.lang}</div>
                            )
                        })
                    }
                </div>
            </div>
        </footer>
    )
}
export default Footer
